export enum VideoTypeEnum {
    Normal = "Normal",
    Bus = "Bus",
    Cancelled = "Cancelled",
    Delay = "Delay",
    LongDelay = "LongDelay",
    NoPlatform = "NoPlatform"
}